export default __webpack_public_path__ + "static/media/Layer 2 (3).617f0666.svg";